export default "__VITE_ASSET__CzMeMdnJ__"